module.exports = __webpack_public_path__ + "img/恐龙带盖陶瓷杯.600f4f63.jpg";